import React from 'react';

import { withSubmission } from '../common/container/Form.jsx';
import { Fullscreen as LoadingFull } from '../common/container/Loading.jsx';
import { Onboarding as Input } from '../common/input/Text.jsx';

function PasswordReset(props) {
    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState(undefined);
    const handleError = (jqXHR) => {
        setLoading(false);
        setMessage(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message || 'There was an error with your request. Please wait a moment and try again.')
    }
    const handleSubmit = (data, callback) => {
        if (!data.Password || data.Password.length == 0) {
            return;
        }
        if (data.ConfirmPassword != data.Password) {
            setMessage('Password and confirmation password must match.');
            return;
        }
        setMessage(undefined);
        setLoading(true);

        const postData = { Code: props.code, ConfirmPassword: data.ConfirmPassword, Password: data.Password };
        Artcloud.api.put(
            Artcloud.url.mkt.reset(),
            postData,
            (responseData) => {
                window.location = responseData.redirectUrl;
                if (callback) {
                    callback(responseData);
                }
            },
            handleError
        );
    }
    return (
        <div className="wrapper--onboarding">
            <div className="grid--onboarding">
                <div className="brand">
                    <img className="logo" src="/assets/img/logos/header-mark-left.svg" />
                </div>
                <div className="form-header">
                    <h1>Reset your password</h1>
                    <p>Please enter your new password.</p>
                </div>
                <div className="form-body">
                    <ResetForm
                        loading={loading}
                        message={message}
                        onSubmit={handleSubmit} />
                </div>
            </div>
        </div>
    )
}

function _ResetForm(props) {
    return (
        <>
            <div className="form-body__grid--boxes form-body__grid--boxes--2">
                <div className="input-wrapper">
                    <label>Password</label>
                    <Input
                        name="Password"
                        required={true}
                        type="password"
                        value={props.state.Password}
                        onChange={props.onChange} />
                </div>
                <div className="input-wrapper">
                    <label>Confirm Password</label>
                    <Input
                        name="ConfirmPassword"
                        required={true}
                        type="password"
                        value={props.state.ConfirmPassword}
                        onChange={props.onChange} />
                </div>
                {props.loading && <LoadingFull />}
            </div>
            <div className="form-body__footer gap--24">
                {/* <Checkbox
                    display={<>Accept <a href="https://artcloud.com/terms" target="_blank">terms of service</a></>}
                    name="HasAgreedToTerms"
                    value={props.state.HasAgreedToTerms == true}
                    onChange={handleChange} /> */}
                <button className="btn" type="submit">
                    Continue
                </button>
            </div>
        </>
    );
}
const ResetForm = withSubmission(_ResetForm);

export default PasswordReset;